import { TCssFontSize, TCssLineHeight } from '@cian/ui-kit/prev/types';

export const FONT_DESKTOP_MAPPER = {
  default: {
    fontSize: '16' as TCssFontSize,
    lineHeight: '22' as TCssLineHeight,
  },
  small: {
    fontSize: '14' as TCssFontSize,
    lineHeight: '20' as TCssLineHeight,
  },
  verySmall: {
    fontSize: '12' as TCssFontSize,
    lineHeight: '18' as TCssLineHeight,
  },
  h1: {
    fontSize: '36' as TCssFontSize,
    lineHeight: '48' as TCssLineHeight,
  },
  h2: {
    fontSize: '28' as TCssFontSize,
    lineHeight: '36' as TCssLineHeight,
  },
  h3: {
    fontSize: '22' as TCssFontSize,
    lineHeight: '28' as TCssLineHeight,
  },
  h4: {
    fontSize: '18' as TCssFontSize,
    lineHeight: '24' as TCssLineHeight,
  },
};

export const FONT_MOBILE_MAPPER = {
  ...FONT_DESKTOP_MAPPER,
  h1: {
    fontSize: '28' as TCssFontSize,
    lineHeight: '36' as TCssLineHeight,
  },
  h2: {
    fontSize: '22' as TCssFontSize,
    lineHeight: '28' as TCssLineHeight,
  },
  h3: {
    fontSize: '18' as TCssFontSize,
    lineHeight: '24' as TCssLineHeight,
  },
  h4: {
    fontSize: '16' as TCssFontSize,
    lineHeight: '22' as TCssLineHeight,
  },
};
